import React from 'react';
import Mutation from '@dietlabs/components/src/Apollo/Mutation';
import PropTypes from 'prop-types';
import SendRequestToRemoveAccountQuery from './SendRequestToRemoveAccountMutation';

class ChangePasswordConnector extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
    };

    render() {
        const { children } = this.props;
        return (
            <Mutation mutation={SendRequestToRemoveAccountQuery}>
                {(sendRequestToRemoveAccount, { loading }) => {
                    const result = {
                        sendRequestToRemoveAccount,
                        loading,
                    };
                    return children(result);
                }}
            </Mutation>
        );
    }
}

export default ChangePasswordConnector;
